import {create} from 'zustand';

const useSignatoryElementStore = create((set) => ({
    signatoryEmailValue: '', // Initial state
    setSignatoryEmailValue: (value) => set({ signatoryEmailValue: value }), // Action to update state
}));

export default useSignatoryElementStore;
